var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"primary","size":_vm.size,"disabled":_vm.disabled},on:{"click":_vm.doXiaoshou}},[_vm._v("\n    生成销售单据\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }